module.exports = __webpack_public_path__ + "img/DE01903.2cc22c76.png";